<template>
  <v-snackbar
    v-model="open"
    top
    :timeout="5000"
    :color="$props.type"
  >
    <template v-for="(message, index) in $props.messages">
      &bull; {{ message }}
      <br :key="index">
    </template>
  </v-snackbar>
</template>

<script>
export default {
  name: 'AppSnackbar',
  props: {
    messages: {
      type: Array,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      open: false,
    };
  },
};
</script>

<style>
  .v-snack__content {
    height: auto;
  }
</style>
